import { IOrdersEffectivenessDrilldownSchema } from './order-effectiveness-drilldown-schema.interface';
import { IStatisticSchema } from './statistic-schema.interface';
export interface IOrdersEffectivenessSchema {
    successfulOrders?: IStatisticSchema;
    successfulOrdersPercentage?: IStatisticSchema;
    failedOrders?: IStatisticSchema;
    failedOrdersPercentage?: IStatisticSchema;
    partialOrders?: IStatisticSchema;
    partialOrdersPercentage?: IStatisticSchema;
    totalOrders?: IStatisticSchema;
    drilldown?: IOrdersEffectivenessDrilldownSchema;
}
